import currentlyShownActions from '../actions/CurrentlyShownActions';

const { types } = currentlyShownActions;

export default function (state = {}, action) {
    const { routeType, sectionId, questionId, scorableItem, route } = action;

    switch (action.type) {
    case types.UPDATE_CURRENTLY_SHOWN:
        return Object.assign({}, { routeType, sectionId, questionId, scorableItem, route });

    default:
        return state;
    }
}
